import { useTranslation } from "react-i18next";
import { FormInput } from "@/shared/Components";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";

type Props = {
  index: number;
  onBlur?: () => void;
  onChange?: () => void;
};
export const EmailField = ({ index, onBlur, onChange }: Props) => {
  const { t } = useTranslation();

  const handleBlur = () => {
    onBlur?.();
  };

  return (
    <FieldLayout>
      <FormInput
        name={`emails.${index}.emailType.name`}
        placeholder={t("contactsPage.generalInfo.type")}
        onBlur={handleBlur}
        customOnChange={onChange}
      />
      <FormInput
        name={`emails.${index}.email`}
        placeholder="example@email.dev"
        onBlur={handleBlur}
      />
    </FieldLayout>
  );
};
